<template>
    <div class="wp">
        <div class="w-1200 home-search-1">
            <div class="title-more">
                <i class="el-icon-s-home" style="color:#615E61;position:relative;top:16px;left:10px;"> </i>
                <el-breadcrumb style="width:90%;padding-left:40px;"  separator=" - ">
                        <el-breadcrumb-item >首页</el-breadcrumb-item>
                        <el-breadcrumb-item>搜索结果</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="h-s-b" v-loading="loading">
                    <div class="input">
                        <el-input
                        style="width:400px;"
                            placeholder="请输入需要搜索的内容"
                            prefix-icon="el-icon-search"
                            v-model="word">
                        </el-input>
                        <el-button type="primary" style="background:#308BE7;" @click="search">搜索</el-button>
                    </div>
                    <p class="result">包含关键词为  “ <span style="color:#FF3000;">{{text}}</span> ”  的搜索结果如下，共找到<span style="color:#0481F1;">{{page.totalPage}}</span>条记录</p>
                     <com-list breadTitle="搜索" returnType='item' :list="list" @getDetail="getDetail"></com-list>
                    <!-- <div v-for="(item,index) in list" :key="index" class="item pointer" @click="getDetail('搜索',item)">
                        <div class="circle"></div>
                        <p class="pull-left p1 p-lv">{{item.title}}</p>
                        <p class="pull-right p2" style="width:100px;">{{item.publishDate}}</p>
                    </div> -->
                </div>
                <z-page :pageObj="page" @changePage1="changePage"></z-page>
        </div>
    </div>
</template>
<script>
import HomeSearch from './HomeSearch.js';
export default HomeSearch;
</script>
<style lang="scss" scoped>
@import './HomeSearch.scss';
</style>